export default {
  header: 'components.views.generate-dieline-view.header',
  generatorPlaceholder: 'components.views.generate-dieline-view.placeholder'
}
